import clsx from "clsx"
import { FC, ReactNode } from "react"
import style from "./Card.module.css"

type CardProps = {
  className?: string
  children: ReactNode
  onClick?: () => void
  /**
   * Renders the card as a native `button` instead of a `div`.
   *
   * Use this when the whole card performs an action, such as selecting a question.
   * Native button semantics make the card keyboard-operable and expose the action
   * correctly to assistive technologies without recreating that behavior on a `div`.
   */
  asButton?: boolean
  "aria-pressed"?: boolean
}

export const Card: FC<CardProps> = ({
  className,
  children,
  onClick,
  asButton = false,
  "aria-pressed": ariaPressed,
}) => {
  const cardClassName = clsx(style["card-base"], className)

  if (asButton) {
    return (
      <button
        type={"button"}
        className={cardClassName}
        onClick={onClick}
        aria-pressed={ariaPressed}
        data-clickable={onClick !== undefined}
      >
        {children}
      </button>
    )
  }

  return (
    <div
      className={cardClassName}
      onClick={onClick}
      data-clickable={onClick !== undefined}
    >
      {children}
    </div>
  )
}
